export enum MemberDegreeType {
    PHD = 'Ph.D',
    MS = 'MS',
    BS = 'BS',
    UNDER_GRADUATE = 'Undergraduate',
}
